import React, { HTMLAttributes, ReactNode } from 'react';

import './Icon.scss';

export const Icon = (props: HTMLAttributes<SVGElement> & { children?: ReactNode; icon: string }) => {
    const href = '/_Resources/Static/Packages/GesagtGetan.Theme/Assets/Sprite.svg#icon-' + props.icon;
    const className = ['icon', 'icon--' + props.icon, props.className].join(' ');

    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
            className={className}
        >
            <use xlinkHref={href} href={href} />
        </svg>
    );
};
